import React, { useEffect } from "react";
import AboutSecetion from "../../components/aboutSection/AboutSecetion";
import BrandSection from "../../components/brandSection/BrandSection";
import Campaign from "../../components/campaignSection/Campaign";
import DecauseWeCam from "../../components/decauseWeCan/DecauseWeCam";
import Feature from "../../components/feature/Feature";
import LatestNews from "../../components/letestNews/LatestNews";
import MissionSection from "../../components/missionSection/MissionSection";
import Slider from "../../components/slider/Slider";
import TopCountSection from "../../components/topCountSection/TopCountSection";

const Home = () => {
  useEffect(() => {
    document.title = "Home";
  }, []);
  return (
    <div className="home">
      <Slider />
      <TopCountSection />
      <AboutSecetion />
      <BrandSection />
      <MissionSection />
      <Campaign />
      <DecauseWeCam />
      {/* <UpcommingEvent/> */}
      {/* <MeetOurTeam/> */}
      {/* <BecomeYoutuber/> */}
      <Feature />
      <LatestNews />
    </div>
  );
};

export default Home;
